const SuperAdminTaxEndPoint = {
  getTaxSettings: {
    url: "/payment-general-setting",
    method: "GET",
  },

  addTaxSettings: {
    url: "/payment-general-setting",
    method: "POST",
  },

  updateTaxSettings: {
    url: "/payment-general-setting",
    method: "PUT",
  }
};

export default SuperAdminTaxEndPoint;
